<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <model-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></model-add-form>
                <model-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></model-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import ModelAddForm from '../components/forms/add/representations/WizardForm'
    import ModelUpdateForm from '../components/forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../modelStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            ModelAddForm,
            ModelUpdateForm
        },

    }
</script>
